import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/intel`;
const PIN_KEY = "intel_owner_pin";

export const getOwnerPin = () => {
  try {
    return localStorage.getItem(PIN_KEY) || "";
  } catch (e) {
    return "";
  }
};
export const setOwnerPin = (pin) => {
  try {
    if (pin) localStorage.setItem(PIN_KEY, pin);
    else localStorage.removeItem(PIN_KEY);
  } catch (e) {
    // ignore
  }
};

const clean = (params = {}) =>
  Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "" && v !== "All"));

export const intelApi = {
  metrics: () => axios.get(`${API}/metrics`).then((r) => r.data),
  weekly: () => axios.get(`${API}/weekly`).then((r) => r.data),
  teaser: () => axios.get(`${API}/teaser`).then((r) => r.data),
  brief: (week) => axios.get(`${API}/brief/${encodeURIComponent(week)}`).then((r) => r.data),
  briefs: () => axios.get(`${API}/briefs`).then((r) => r.data),
  shareUrl: (week) => `${API}/s/${week}`,
  digestPreview: (week) =>
    axios
      .get(`${API}/digest/preview`, { params: week ? { week } : {}, headers: { "X-Owner-Pin": getOwnerPin() }, responseType: "text" })
      .then((r) => r.data),
  digestNext: () => axios.get(`${API}/digest/next`, { headers: { "X-Owner-Pin": getOwnerPin() } }).then((r) => r.data),
  sendDigest: () =>
    axios.post(`${API}/digest/send`, {}, { headers: { "X-Owner-Pin": getOwnerPin() } }).then((r) => r.data),
  sources: () => axios.get(`${API}/sources`).then((r) => r.data),
  updates: (params) => axios.get(`${API}/updates`, { params: clean(params) }).then((r) => r.data),
  timeline: (params) => axios.get(`${API}/timeline`, { params: clean(params) }).then((r) => r.data),
  verifyPin: (pin) => axios.post(`${API}/auth/verify`, { pin }).then((r) => r.data),
  patch: (id, body) =>
    axios.patch(`${API}/updates/${id}`, body, { headers: { "X-Owner-Pin": getOwnerPin() } }).then((r) => r.data),
  runIngest: () =>
    axios.post(`${API}/ingest/run`, {}, { headers: { "X-Owner-Pin": getOwnerPin() } }).then((r) => r.data),
};

export const fmtDate = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
    : "";

export const fmtDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })
    : "—";

export const IMPORTANCE_STYLES = {
  Critical: "bg-destructive text-destructive-foreground border-destructive",
  High: "bg-accent text-accent-foreground border-accent",
  Medium: "bg-transparent text-foreground border-foreground/40",
  Low: "bg-transparent text-muted-foreground border-border",
};
